import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosNewInstance } from "../../config/Api";
import toast from "react-hot-toast";

export const RoleForm = ({ editRole, onFormSubmit, handleFormCancel }) => {
  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Role Name
      status: "1", // Default as Active
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Role Name is required"),
      status: Yup.string().required("Status is required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        const token = localStorage.getItem("authToken");
        const url = Object?.keys(editRole)?.length > 0 ? `/api-app/update-roles` : "/api-app/store-roles";

        const payload = {
          name: values.name,
          status: values.status,
          ...(editRole && { id: editRole.id }),
        };

        const response = await axiosNewInstance.post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        toast.success(
          Object?.keys(editRole)?.length > 0
            ? "Role updated successfully!"
            : "Role added successfully!"
        );
        resetForm();
        onFormSubmit();
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          "Failed to submit form. Please try again.";
        console.error("Error submitting form:", errorMessage);
        toast.error(errorMessage);
      }
    },
  });

  useEffect(() => {
    if (Object?.keys(editRole)?.length > 0) {
      formik.setValues({
        name: editRole.name || "",
        status: editRole.status?.toString() || "1",
      });
    }
  }, [editRole]);

  console.log("edit Role 333", editRole);

  return (
    <div className="card shadow-sm mt-4">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">
          {Object?.keys(editRole)?.length > 0 ? "Edit Role" : "Add New Role"}
        </h5>
      </div>
      <div className="card-body">
        <form onSubmit={formik.handleSubmit} className="needs-validation">
          <div className="row">
            {/* Role Name Field */}
            <div className="col-md-6 mb-3">
              <label htmlFor="name" className="form-label">
                Role Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""
                  }`}
                id="name"
                name="name"
                placeholder="Enter Role Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="invalid-feedback">{formik.errors.name}</div>
              )}
            </div>

            {/* Status Field */}
            <div className="col-md-6 mb-3">
              <label htmlFor="status" className="form-label">
                Status <span className="text-danger">*</span>
              </label>
              <select
                className={`form-control ${formik.touched.status && formik.errors.status
                    ? "is-invalid"
                    : ""
                  }`}
                id="status"
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              {formik.touched.status && formik.errors.status && (
                <div className="invalid-feedback">{formik.errors.status}</div>
              )}
            </div>
          </div>

          {/* Form Actions */}
          <div className="d-flex justify-content-end">
            {/* <button
              type="reset"
              onClick={formik.handleReset}
              className="btn btn-warning"
            >
              Reset
            </button> */}
            <button
              type="button"
              className="btn btn-secondary px-4 py-2 mx-2"
              style={{ height: "45px" }}
              onClick={handleFormCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ marginLeft: "10px" }}
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting
                ? "Saving..."
                : Object?.keys(editRole)?.length > 0
                  ? "Update"
                  : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
